export const QueryStepParser = (step: string | null): number | undefined => {
    if (step) {
        const stepNum = parseInt(step)
        return isNaN(stepNum) ? undefined : stepNum
    }
    return undefined
}
